import { gql } from "graphql-request";

export const READ_PUBLIC_HOLIDAYS = gql`
  query ReadPublicHolidays(
    $jurisdiction: HolidayJurisdiction!
    $year: Int!
  ) {
    readPublicHolidays(jurisdiction: $jurisdiction, year: $year) {
      id
      jurisdiction
      name
      date
      observedDate
      year
      source
    }
  }
`;

export const READ_TENANT_LEAVE_YEARS = gql`
  query ReadTenantLeaveYears($tenantID: ID!) {
    readTenantLeaveYears(tenantID: $tenantID) {
      id
      tenantID
      startDate
      endDate
      status
    }
  }
`;

export const READ_TENANT_USERS_BY_TENANT = gql`
  query ReadTenantUsersByTenant($tenantId: ID!) {
    readTenantUsersByTenant(tenantId: $tenantId) {
      id
      userId
      displayName
      archivedAt
      user {
        id
        firstName
        lastName
        email
      }
    }
  }
`;

export const READ_TENANT_HOLIDAY_SETTINGS = gql`
  query ReadTenantHolidaySettings($tenantID: ID!) {
    readTenantHolidaySettings(tenantID: $tenantID) {
      tenantID
      publicHolidayJurisdiction
      leaveYears {
        id
        startDate
        endDate
        status
      }
    }
  }
`;

export const READ_STAFF_WORK_PATTERNS = gql`
  query ReadStaffWorkPatterns(
    $tenantID: ID!
    $staffTenantUserID: ID!
    $leaveYearID: ID!
  ) {
    readStaffWorkPatterns(
      tenantID: $tenantID
      staffTenantUserID: $staffTenantUserID
      leaveYearID: $leaveYearID
    ) {
      id
      name
      effectiveFrom
      effectiveTo
      days {
        dayOfWeek
        isWorkingDay
        startTime
        endTime
        scheduledMinutes
      }
    }
  }
`;

export const READ_HOLIDAY_REQUESTS = gql`
  query ReadHolidayRequests($filter: HolidayRequestFilterInput!) {
    readHolidayRequests(filter: $filter) {
      id
      tenantID
      staffTenantUserID
      leaveYearID
      days {
        date
        requestedMinutes
        scheduledMinutes
        chargedMinutes
        isPublicHoliday
      }
      totalRequestedMinutes
      totalChargedMinutes
      status
      comment
      createdAt
    }
  }
`;

